const SvgInfo = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 33 33" {...props}>
    <path
      fill="currentColor"
      fillOpacity={1}
      d="M16.578 6.728c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10m0 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1m1-8h-2v-2h2z"
    />
  </svg>
);

export default SvgInfo;
